export default "__VITE_ASSET__BiLlV43X__"